export default "__VITE_ASSET__29929d33__"